import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
  SaveButton,
  TopToolbar,
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import { rolesFields, CallLineType, RoleType } from '../roles.model';
import { useCreateWithRefresh } from '../../hooks/useMutationWithRefresh';
import { validatePhone } from '../../utils/validation.js';

const useStyles = makeStyles({
  roleName: { display: 'inline-block' },
  lineType: { display: 'inline-block', marginLeft: 32 },
});

const CreateActions = () => (
  <TopToolbar>
    <SaveButton />
  </TopToolbar>
);

const ConditionalLineTypeFields = () => {
  const roleType = useWatch({ name: rolesFields.roleType });
  
  // Only show line_type and phone_number for org_feature, custom_line, and legacy roles
  if (roleType === RoleType.OrgFeature.id || roleType === RoleType.CustomLine.id || roleType === RoleType.Legacy.id || !roleType) {
    return (
      <>
        <SelectInput
          label="Line Type"
          source={rolesFields.lineType}
          helperText="How users access this service (required for org features)"
          choices={[
            CallLineType.VideoChat,
            CallLineType.PhoneNumber,
            CallLineType.PhoneToPacifyProvider,
          ]}
        />
        <TextInput
          type="phone"
          label="Phone Number"
          source={rolesFields.phoneNumber}
          helperText="Required if line type is phone-number or phone-to-pacify-provider"
          validate={validatePhone(false)}
        />
        <TextInput
          label="Title (English)"
          source={rolesFields.titleEnglish}
          helperText="Display title shown to English-speaking patients"
        />
        <TextInput
          label="Title (Spanish)"
          source={rolesFields.titleSpanish}
          helperText="Display title shown to Spanish-speaking patients"
        />
        <TextInput
          label="Info Popup Content (English)"
          source={rolesFields.infoPopupContentEnglish}
          helperText="Description shown in the service popup for English-speaking patients"
          multiline
        />
        <TextInput
          label="Info Popup Content (Spanish)"
          source={rolesFields.infoPopupContentSpanish}
          helperText="Description shown in the service popup for Spanish-speaking patients"
          multiline
        />
        <TextInput
          label="Button Image URL"
          source={rolesFields.buttonImageURL}
          helperText="URL for the service button icon"
        />
        <TextInput
          label="Button Background Color"
          source={rolesFields.buttonBackgroundColor}
          helperText="Hex color for the service button background (e.g. #FFFFFF)"
        />
      </>
    );
  }
  
  return null;
};

const RolesCreate = () => {
  const classes = useStyles();
  const mutationOptions = useCreateWithRefresh('roles');

  return (
    <Create mutationOptions={mutationOptions}>
      <SimpleForm>
        <TextInput
          label="Name"
          source={rolesFields.roleName}
          className={classes.roleName}
          validate={required()}
        />
        <SelectInput
          source={rolesFields.roleType}
          label="Role Type"
          helperText="role_key will be auto-generated for internal_admin, patient, and provider types"
          defaultValue={RoleType.Legacy.id}
          choices={[
            RoleType.InternalAdmin,
            RoleType.Patient,
            RoleType.Provider,
            RoleType.OrgFeature,
            RoleType.CustomLine,
            RoleType.Legacy
          ]}
        />
        <ConditionalLineTypeFields />
      </SimpleForm>
    </Create>
  );
};

export default RolesCreate;
